import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class SecurityInterceptor implements HttpInterceptor {

    constructor(private snackbar: MatSnackBar) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(map(event => {
            if (event instanceof HttpResponse) {
                const body = event.body;             
                if (body) {                    
                    if (typeof body.response.security !== "undefined") {

                        if (body.response.security[0].hasError) {
                            this.snackbar.open(body.response.security[0].sMessageText, 'BELLA+CANVAS', {
                                duration: 1000
                            });
                        }

                        if (body.response.security[0].sLogoutMsg) {
                            this.snackbar.open(body.response.security[0].sLogoutMsg, 'BELLA+CANVAS', {
                                duration: 1000
                            });
                        }

                    }
                }
            }
            return event;
        }));
    }

}
